module.exports = __webpack_public_path__ + "static/media/cg8.02e09d62.jpg";